import { Injectable, computed, signal } from '@angular/core';
import { MappedFilter } from 'src/app/products/services/filters-adapter.service';
import { FilterSelection } from '../filters.component';

@Injectable({
  providedIn: 'root'
})
export class GlobalFiltersService {

  // Filter state
  private _currentAppliedFilters = signal<FilterSelection[]>([]);
  readonly currentAppliedFilters = this._currentAppliedFilters.asReadonly();

  private _aggregations = signal<MappedFilter[] | null>(null);
  readonly aggregations = this._aggregations.asReadonly();

  // Sorting state
  private _sortBy = signal<string>('');
  readonly sortBy = this._sortBy.asReadonly();

  // Base filters state
  private _baseFilters = signal<Record<string, any>>({});
  readonly baseFilters = this._baseFilters.asReadonly();

  // Track when base filters actually change (for aggregation refresh)
  private _baseFiltersChanged = signal<boolean>(false);
  readonly baseFiltersChanged = this._baseFiltersChanged.asReadonly();

  // Computed signals for derived state
  readonly hasFilters = computed(() => this._currentAppliedFilters().length > 0);
  readonly filterCount = computed(() => this._currentAppliedFilters().length);
  readonly hasSorting = computed(() => this._sortBy() !== '' && this._sortBy() !== 'Sort By');

  // Filter management methods
  clearFilters() {
    this._currentAppliedFilters.set([]);
  }

  applyFilters(filters: FilterSelection[]) {
    this._currentAppliedFilters.set(filters);
  }

  updateAggregations(updatedFilter: MappedFilter[]) {
    this._aggregations.set(updatedFilter);
    // Reset the change flag after aggregations are updated
    this._baseFiltersChanged.set(false);
  }

  setBaseFilters(filters: Record<string, any>) {
    const currentFilters = this._baseFilters();
    const hasChanged = JSON.stringify(currentFilters) !== JSON.stringify(filters);

    // Only update if filters actually changed to prevent unnecessary signal updates
    if (hasChanged) {
      this._baseFilters.set(filters);
      this._baseFiltersChanged.set(true);
    }
  }

  // Sorting management methods
  setSortBy(sortValue: string) {
    this._sortBy.set(sortValue);
  }

  clearSorting() {
    this._sortBy.set('');
  }







}
